import ReactAsyncSelect from "react-select/async";
import { GroupBase } from "react-select";

import FieldWrapper from "../FieldWrapper";

import useCustomStyles from "./hooks";
import { SelectItem, AsyncSelectProps } from "./types";

const AsyncSelect = <
  Option = SelectItem,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  $mode = "light",
  placeholder = "Select...",
  error,
  ...rest
}: AsyncSelectProps<Option, IsMulti, Group>): React.ReactElement => {
  const customStyles = useCustomStyles<Option, IsMulti, Group>($mode);

  return (
    <FieldWrapper
      {...{ error }}
      controller={
        <ReactAsyncSelect
          className="select"
          styles={customStyles}
          maxMenuHeight={180}
          {...{ placeholder, ...rest }}
        />
      }
    />
  );
};

export default AsyncSelect;
